var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#80d4ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0 39.431 55.015-39.431 55.015-256-40.33v-26.26c0-23.95 19.49-43.44 43.44-43.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 110.03 79.21 136.678-79.21 119.292h-212.56c-23.95 0-43.44-19.49-43.44-43.44v-182.26z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m512 43.44v26.26l-256 40.33v-110.03h212.56c23.95 0 43.44 19.49 43.44 43.44z",
    fill: "#66b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 140.3v182.26c0 23.95-19.49 43.44-43.44 43.44h-212.56v-255.97z",
    fill: "#66b3ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 69.7 48.139 37.669-48.139 32.931h-256v-70.6z",
    fill: "#5f55b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m161.79 210h-86.79c-8.284 0-15-6.716-15-15s6.716-15 15-15h86.79c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#5f55b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437 210h-86.79c-8.284 0-15-6.716-15-15s6.716-15 15-15h86.79c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#5f55b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 226.84 83.576 148.885-83.576 124.875c-75.48 0-136.88-61.4-136.88-136.88s61.4-136.88 136.88-136.88z",
    fill: "#fb3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.88 363.72c0 75.48-61.4 136.88-136.88 136.88v-273.76c75.48 0 136.88 61.4 136.88 136.88z",
    fill: "#ff9934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 245.44 14.927-15.194-14.927-14.806c-81.76 0-148.28 66.52-148.28 148.28s66.52 148.28 148.28 148.28l17.437-18.875-17.437-11.125c-65.22 0-118.28-53.06-118.28-118.28s53.06-118.28 118.28-118.28z",
    fill: "#ffe666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.003 405.625 9.393 17.903-9.393 28.627c-8.28 0-15-6.72-15-15v-3.64c-12.84-3.25-24.42-10.02-33.12-19.63-5.57-6.13-5.1-15.62 1.04-21.18 6.14-5.57 15.62-5.1 21.19 1.04 6.24 6.88 15.76 11.22 25.89 11.88z",
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.583 330.755c-.59 3.05.19 6.18 2.99 7.6 2.41 1.05 6.86 2.96 12.43 5.24l8.626 13.813-8.626 18.317c-15.23-5.9-23.16-7.93-33.33-15.51-9.97-8.91-14.33-22.7-11.38-35.97 3.19-14.32 14.05-25.57 29.06-30.1.22-.06.44-.11.65-.17v-3.69c0-8.28 6.72-15 15-15l12.017 30.588-12.017 15.892c-2.28.05-4.63.39-7 1.11-6.22 1.87-7.95 5.74-8.42 7.88z",
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.903 327.285c-4.96 6.88-14.83 8.16-21.3 2.64 0 0-10.68-8.53-23.6-8.16v-46.48c8.29 0 15 6.72 15 15v3.15c16.18 3.86 27.2 12.93 27.9 13.52 6.11 5.09 7 14.15 2 20.33z",
    fill: "#daebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.423 398.645c-3.17 17.75-17.7 31.46-36.42 35.7v2.81c0 8.28-6.71 15-15 15v-46.53c.9.06 1.81.09 2.72.09 10.62 0 18.09-6.28 19.17-12.34 1.45-8.14-10.71-13.3-14.47-14.69-2.66-1.1-5.13-2.08-7.42-2.96v-32.13c5.2 2.14 11.39 4.59 17.81 6.95 29.19 10.77 36.5 31.91 33.61 48.1z",
    fill: "#daebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.28 363.72c0 81.76-66.52 148.28-148.28 148.28v-30c65.22 0 118.28-53.06 118.28-118.28s-53.06-118.28-118.28-118.28v-30c81.76 0 148.28 66.52 148.28 148.28z",
    fill: "#fb3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 69.7h256v70.6h-256z",
    fill: "#453d86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodIcon);
export default __webpack_public_path__ + "static/media/paymentMethodIcon.7bf01403c2fd623a5eb396b37259ed3e.svg";
export { ForwardRef as ReactComponent };